import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import { PATH_ROUTES } from 'routes/path';
import GeneratingImage from 'assets/images/symptom-checker/symptom_generating.png';
import { cn } from 'lib/utils';

export default function SymptomCheckerGenerating({
  isDetails = false,
}: {
  isDetails?: boolean;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'lg:h-[calc(100vh-8rem)] flex items-center justify-center flex-col max-w-5xl mx-auto py-8'
      )}
    >
      <div className='flex flex-col items-center justify-center space-y-4 md:space-y-8'>
        <img
          src={GeneratingImage}
          alt='generating'
          className='object-contain w-full h-60'
        />
        <div className='w-full px-4 space-y-4 text-center md:w-1/2'>
          <h2 className='text-base font-semibold whitespace-pre md:text-lg'>
            {t('generating_symptom_title')}
          </h2>
          <p className='text-sm font-medium md:text-base'>
            {t('generating_symptom_desc')}
          </p>
        </div>
        {!isDetails ? (
          <Button
            className='px-6 text-sm h-9 md:text-base'
            onClick={() => {
              navigate(PATH_ROUTES.SYMPTOM_CHECKER);
            }}
          >
            {t('go_to_reports')}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
